<template>
    <div>
        <v-toolbar dark color="primary">
            <v-icon>edit</v-icon>
            <v-toolbar-title class="white--text" v-if="isCreate">Create User</v-toolbar-title>
            <v-toolbar-title class="white--text" v-else>Edit User</v-toolbar-title>

            <v-spacer></v-spacer>

            <v-btn icon @click="close">
                <v-icon>close</v-icon>
            </v-btn>
        </v-toolbar>
        <v-tabs v-model="tab" dark color="primary">
            <v-tab href="#tab-data">Data</v-tab>
            <v-tab href="#tab-text">Settings</v-tab>
            <v-tab href="#tab-order-history">Order history</v-tab>
        </v-tabs>
        <v-card>
            <v-card-text>
                <v-tabs-items v-model="tab">
                    <v-tab-item value="tab-data">
                        <v-container grid-list-xl>
                            <v-form ref="form" v-model="isValid">
                                <v-layout wrap justify-space-between>
                                    <v-flex xs12>
                                        <v-text-field
                                            v-model="u.username"
                                            :rules="rules.usernameRules"
                                            label="Username"
                                            required
                                        ></v-text-field>
                                        <v-text-field
                                            v-if="isCreate"
                                            name="password"
                                            label="Password"
                                            id="password"
                                            type="password"
                                            v-model="u.password"
                                            required
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12 md6>
                                        <v-text-field
                                            v-model="u.firstname"
                                            :rules="rules.nameRules"
                                            label="First name"
                                            required
                                        ></v-text-field>
                                        <v-select
                                            :items="companies"
                                            :rules="rules.companyRule"
                                            v-model="u.company"
                                            item-text="Name"
                                            item-value="_id"
                                            label="Company"
                                            required
                                        ></v-select>
                                        <v-switch label="Show VAT costs" v-model="u.showVAT"></v-switch>
                                    </v-flex>
                                    <v-flex xs12 md6>
                                        <v-text-field
                                            v-model="u.lastname"
                                            :rules="rules.nameRules"
                                            label="Lastname"
                                            required
                                        ></v-text-field>
                                        <v-text-field
                                            v-model="u.email"
                                            :rules="rules.emailRules"
                                            label="Email"
                                            required
                                        ></v-text-field>
                                        <v-switch label="Is Administrator" v-model="u.isAdmin"></v-switch>
                                        <v-switch label="Is Formula E" v-model="u.isFormulaE"></v-switch>
                                    </v-flex>
                                </v-layout>
                            </v-form>
                        </v-container>
                    </v-tab-item>
                    <v-tab-item value="tab-text">
                        <v-container grid-list-xl>
                            <v-form>
                                <v-layout wrap justify-space-between>
                                    <v-flex xs12 md6>
                                        <v-select
                                            :items="languages"
                                            item-text="name"
                                            item-value="locale"
                                            v-model="u.settings.language"
                                            label="Language"
                                        ></v-select>
                                        <v-select
                                            :items="seasons"
                                            item-value="id"
                                            item-text="year"
                                            v-model="u.settings.season"
                                            :label="$t('message.season')"
                                        ></v-select>
                                        <v-switch label="Dark mode" v-model="u.settings.isDarkMode"></v-switch>
                                        <v-switch label="Show Waitinglist" v-model="u.settings.showWaitingList"></v-switch>
                                        <v-switch label="Show Guest Details" v-model="u.settings.showGuestDetails"></v-switch>
                                        <v-switch label="Show Reconcilliation" v-model="u.settings.showRecon"></v-switch>
                                        <v-switch label="Show Order Histories" v-model="u.settings.showOrders"></v-switch>
                                        <v-text-field
                                            v-model="u.settings.partnerLinkPart"
                                            label="Partner Link"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12 md6></v-flex>
                                </v-layout>
                            </v-form>
                        </v-container>
                    </v-tab-item>
                    <v-tab-item value="tab-order-history">
                        <v-container grid-list-xl>
                            <v-form>
                                <v-layout wrap justify-space-between>
                                    <v-flex xs12 md6>
                                        <ArticleTypeSelectBox
                                            v-model="u.settings.orderHistoryArticles"
                                            :label="{
                                                en: 'Order history articles',
                                                de: 'Order History Artikel'
                                            }"
                                        />
                                        <v-select
                                            label="Canceled orders style"
                                            v-model="u.settings.orderHistoryCanceledStyle"
                                            :items="canceledStyles"
                                        />
                                        <v-switch
                                            boxed
                                            label="Show FOHES columns"
                                            v-model="u.settings.orderHistoryShowFohesColumns"
                                        />
                                        <v-switch
                                            label="Show tracking id column"
                                            v-model="u.settings.orderHistoryShowTrackingColumns"
                                        />
                                        <v-switch
                                            label="Show required logo column"
                                            v-model="u.settings.orderHistoryShowRequiredLogo"
                                        />
                                    </v-flex>
                                    <v-flex xs12 md6>
                                        <shop-colors v-model="u.settings.orderHistoryShopColors" />
                                    </v-flex>
                                </v-layout>
                            </v-form>
                        </v-container>
                    </v-tab-item>
                </v-tabs-items>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="green darken-1" flat="flat" @click="close">Cancel</v-btn>
                <v-btn color="green darken-1" flat="flat" @click="save()" :disabled="!isValid">Save</v-btn>
            </v-card-actions>
        </v-card>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'

import ArticleTypeSelectBox from '../dashboards/widget-setting-components/ArticleTypeSelectBox'
import canceledStyles from '../../../constants/order-history-canceled-styles'
import ShopColors from './UserForm/ShopColors'

export default {
    components: {
        ArticleTypeSelectBox,
        ShopColors
    },
    props: {
        user: {
            type: Object
        },
        isCreate: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            canceledStyles,
            tab: 'tab-data',
            isValid: false,
            rules: {
                usernameRules: [
                    v => !!v || 'Field is required',
                    v => (v && v.length >= 3) || 'Name must be less than 10 characters'
                ],
                nameRules: [
                    v => !!v || 'Field is required',
                    v => (v && v.length >= 2) || 'Name must be more than 2 characters'
                ],
                emailRules: [v => !!v || 'E-mail is required', v => /.+@.+/.test(v) || 'E-mail must be valid'],
                companyRules: [v => !!v || 'Company is required']
            },
            u: this.user
        }
    },
    computed: {
        ...mapGetters(['companies', 'seasons', 'languages'])
    },
    methods: {
        close() {
            this.$emit('close')
        },
        save() {
            // validate form
            if (this.$refs.form.validate()) {
                // replace company object with company id
                let p
                const { u } = this
                if (this.isCreate === true) {
                    p = this.$store.dispatch('createUser', u)
                } else {
                    p = this.$store.dispatch('updateUser', u)
                }

                p.then(() => this.$auth.me()).then(() => this.$emit('close'))
            }
        },
        editItem(item) {
            this.$router.push({
                name: 'admin.dashboard',
                params: { id: item.id }
            })
        },
        deleteItem(item) {}
    },
    mounted() {}
}
</script>
